import { Link } from 'react-router-dom';
import { CornerDownLeft } from 'lucide-react';
import TrainigServiceImg from "../../../assets/used-images/services-training-img.png";
import ServiceApplyBtn from '../../ui/ServiceApplyBtn';
import Breadcrumb from '../../Pages/Breadcrumb';
import Image from '../../ui/Image';
import IvoryGold from "../../../assets/icons/IvoryGold.svg";
import IvoryWh from "../../../assets/icons/IvoryList.svg";
import Call from "../../../assets/used-images/call.png";
import ServiceProvider from "../../../assets/used-images/service-provider.png";
import HumanMind from "../../../assets/used-images/human-mind.png";
import Cart from "../../../assets/used-images/shopping-cart.png";
import Chart from "../../../assets/used-images/training-trade.png";
import HandDollar from "../../../assets/used-images/training-hand-dollar.png";
import Gmail from "../../../assets/used-icons/Gmail.svg";
import Whatsapp from "../../../assets/used-icons/Whatsapp.svg";
import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import useAllLists from '../../../hooks/use-all-lists';
import { useLanguage } from '../../../store/language-context';
import { useTranslation } from 'react-i18next';


const Training = () => {
    const { URL } = useLanguage();
    const { t } = useTranslation();
    const categoryImgs = [Chart, HandDollar, HumanMind, ServiceProvider, Call, Cart,];

    const { categories, catLoad, catErr, refetchCategories: refetch } = useAllLists({ includeWhat: ['categories'] })

    const subjectsOfBoxsIds = [34, 35, 61, 62, 64];
    const { data: subjectsOfBoxs, isLoading: boxsLoading, error: boxsErr, refetch: refetchBoxs } = useQuery({
        queryKey: ['subjects-of-boxs', subjectsOfBoxsIds, URL],
        queryFn: async () => {
            const responses =
                await Promise.all(
                    subjectsOfBoxsIds.map(id => axios.get(`${URL}/subjects/${id}`))
                );
            return responses.map(res => res.data.data);
        },
    });
    const pages = [
        {
            title: t('routes.training-plan'),
            href: '/training-plan'
        },
        {
            title: t('routes.accreditations'),
            href: '/dependencies'
        },
        {
            title: t('routes.training-courses'),
            href: '/training-courses?page=1'
        },
    ];
    return (
        <>
            <Breadcrumb pages={[t('routes.services'), t('routes.training')]} />
            <main className='container'>

                <section className='grid grid-cols-[29%_69%] bg-light-gray max-2xl:grid-cols-2 max-2xl:gap-4 max-md:grid-cols-1 border rounded-lg p-2'>
                    <div className='p-2 relative border-2 border-secondary-tw rounded-lg w-[22.25rem] h-60 max-2xl:w-full max-md:h-full'>
                        <Image src={TrainigServiceImg} alt="training-service-img" className='rounded-lg w-full h-full' />
                    </div>
                    <div className='space-y-4'>
                        <p className='services-header'>{t('routes.training')}</p>
                        <article className="text-semi-gray !text-start">
                            {t('training.desc')}
                        </article>
                    </div>
                </section>

                <section className='py-8'>
                    <div className='flex justify-center'>
                        <p className='services-header flex justify-center after:-bottom-2 after:w-28'>
                            {t('training.title-one')}
                        </p>
                    </div>
                    <div className='grid grid-cols-2 gap-10 max-xl:grid-cols-2 max-md:grid-cols-1 py-8'>
                        {
                            catLoad ?
                                <>
                                    {
                                        [...Array(6)].map((_, i) => (
                                            <div key={i} className="flex flex-col items-center gap-4">
                                                <div className='size-16 rounded-full l-load-dt'></div>
                                                <div className='w-32 h-5 rounded-md l-load-dt'></div>
                                                <div className="grid gap-2 lg:grid-cols-2 lg:gap-6 w-full">
                                                    {
                                                        [...Array(6)].map((_, iTwo) => (
                                                            <div key={iTwo} className="w-full h-4 rounded-md l-load-dt"></div>
                                                        ))
                                                    }
                                                </div>
                                            </div>
                                        ))
                                    }
                                </>
                                :
                                catErr ?
                                    <div>
                                        <p className="text-red-500">{t('custom.err')}</p>
                                        <button
                                            className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                                            onClick={() => refetch()}
                                        >
                                            {t('custom.try-again')}
                                        </button>
                                    </div>
                                    :
                                    <>
                                        {
                                            categories?.slice(0, 6)?.map((box, i) => (
                                                <div key={i} className='border p-3 rounded-md space-y-3'>
                                                    <div className='flex justify-center'>
                                                        <div className='border-secondary-tw border-2 size-12 rounded-full flex justify-center items-center'>
                                                            <img src={categoryImgs[i]} alt={`${box.title}-icon`} />
                                                        </div>
                                                    </div>
                                                    <Link to={`/training-plan/${box?.id}`} className='text-xl font-bold text-secondary-tw hover:text-secondary-tw/70'>
                                                        {box.title}
                                                    </Link>
                                                    <div className='grid grid-cols-2 gap-2 p-2'>
                                                        {
                                                            box?.subjects?.map((subject, iSubject) => (
                                                                <Link to={`/subject-courses/${subject?.id}`} className="flex items-start gap-2 hover:text-common-text/70" key={iSubject}>
                                                                    <div className='w-4'>
                                                                        <img src={IvoryGold} alt="gold-ivory" className='w-3 mt-1' />
                                                                    </div>
                                                                    <p className='text-secondary-tw text-base !text-start'>
                                                                        {subject?.title}
                                                                    </p>
                                                                </Link>
                                                            ))
                                                        }

                                                    </div>
                                                </div>
                                            ))
                                        }

                                    </>
                        }
                    </div>
                </section>
            </main>
            {/* subject of boxs */}
            <section className='bg-primary-tw py-4  space-y-8'>
                <div className="container">
                    <div className='flex justify-center'>
                        <p className='services-header text-white after:w-32 after:-bottom-2 flex justify-center'>
                            {t('training.title-two')}
                        </p>
                    </div>
                    <div className='scrolling gap-4 lg:flex lg:justify-space-between mt-4 justify-content-between'>
                        {
                            boxsLoading ?
                                <>
                                    {
                                        [...Array(5)].map((_, i) => (
                                            <div key={i} className="flex w-56 h-28 p-3 flex-col items-center l-load rounded-md border">
                                                <div className='size-10 l-load-dt rounded-full'></div>
                                                <div className='w-56 h-6'></div>
                                                <div className='w-32 h-5 rounded-md l-load-dt'></div>
                                            </div>
                                        ))
                                    }
                                </>
                                :
                                boxsErr ?
                                    <div>
                                        <p className="text-red-500">{t('custom.err')}</p>
                                        <button
                                            className="mt-2 bg-secondary-tw text-white px-4 py-2 rounded-md"
                                            onClick={() => refetchBoxs()}
                                        >
                                            {t('custom.try-again')}
                                        </button>
                                    </div>
                                    :
                                    <>
                                        {subjectsOfBoxs.map((box, i) => (
                                            <Link key={box?.id || i} to={`/subject-courses/${box?.id}`}>
                                                <div key={i} className='border bg-light-gray text-white text-xl w-56 h-40 p-3 flex flex-col justify-items-center items-center gap-4 rounded-lg'>
                                                    <div className='w-52 flex justify-center '>
                                                        <img src={IvoryGold} alt="ivory-icon" className='w-6' />
                                                    </div>
                                                    <p>{box?.title}</p>
                                                </div>
                                            </Link>
                                        ))}
                                    </>
                        }
                    </div>
                </div>
            </section>

            <div className="container">
                <main className='grid grid-cols-3 justify-items-center max-xl:grid-cols-2 max-md:grid-cols-1 gap-20  py-10 mt-5'>
                    {
                        catLoad ?
                            <p>Loading....</p>
                            :
                            categories?.slice(6, 15)?.map((sec, i) => (
                                <div className='relative rounded-lg p-3' key={i}>
                                    <div className='absolute block z-0 size-64 -top-14 -right-9 rounded-lg max-lg:-right-16'>
                                        <img src={sec?.image} alt={`${sec.title}-image`} className='object-cover w-full h-full rounded-lg' />
                                    </div>
                                    <div className='relative pt-2 h-96 w-72 -left-10 z-30 bg-white rounded-lg border-2 border-secondary-tw'>
                                        <Link to={`/training-plan/${sec?.id}`} className='text-secondary-tw text-xl hover:text-secondary-tw/70'>
                                            {sec?.title}
                                        </Link>
                                        <div className='p-2'>
                                            {sec?.subjects?.slice(0, 6)?.map((subject, iS) => (
                                                <Link to={`/subject-courses/${subject?.id}`} key={iS} className='flex items-center gap-2 text-common-text hover:text-common-text/70'>
                                                    <div>
                                                        <CornerDownLeft size={20} color='#414042' className='ltr:-rotate-180 ltr:mb-2' />
                                                    </div>
                                                    <p className=' truncate'>{subject?.title}</p>
                                                </Link>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            ))
                    }
                </main>
            </div>
            {/* contacting */}
            <main className='container'>
                <div className='flex justify-center'>
                    <p className='services-header after:-bottom-2 after:w-32 flex justify-center'>
                        {t('training.title-three')}
                    </p>
                </div>
                <section className='border rounded-lg p-4 grid grid-cols-2 gap-4 max-lg:grid-cols-1'>
                    {/* GMAIL */}
                    <div className='!text-start'>
                        <div className='flex items-center gap-2'>
                            <div>
                                <img src={Gmail} alt="gmail-account" className='mb-2.5' />
                            </div>
                            <p>
                                {t('contact.email')}
                            </p>
                        </div>
                        <Link to={`mailto:marketing@ivorytraining.com`} className='text-secondary-tw'>
                            marketing@ivorytraining.com
                        </Link>
                    </div>
                    {/* SERVICE */}
                    {/* <div className='!text-start'>
                        <div className='flex items-center gap-2'>
                            <div>
                                <img src={Settings} alt="service-req" />
                            </div>
                            <p>
                                الخدمة
                            </p>
                        </div>
                        <button className='text-secondary-tw underline underline-offset-2'>
                            اضغط للتسجيل
                        </button>
                    </div> */}
                    {/* WHATSAPP */}
                    <div className='!text-start'>
                        <div className='flex items-center gap-2'>
                            <div>
                                <img src={Whatsapp} alt="whatsapp-number" className='mb-2.5' />
                            </div>
                            <p>
                                {t('contact.whatsapp')}
                            </p>
                        </div>
                        <Link target='_blank' to={`https://wa.me/+966553599096`} className='text-secondary-tw'>
                            {t('contact.click-to-talk')}
                        </Link>
                    </div>
                </section>
            </main>

            {/* pages */}
            <div className="container">
                <main className='grid grid-cols-3 gap-6 mt-4 py-8  max-xl:grid-cols-2 max-lg:grid-cols-1'>
                    {
                        pages.map((page, i) => (
                            <Link key={i} to={page.href} className='bg-primary-tw p-2 rounded-lg text-white h-52'>
                                <div className='border rounded-lg p-2 flex flex-col gap-4 justify-center items-center h-full'>
                                    <div>
                                        <img src={IvoryWh} alt="ivory-icon" className='w-7' />
                                    </div>
                                    <p className='text-xl'>
                                        {page.title}
                                    </p>
                                </div>
                            </Link>
                        ))
                    }
                </main>
            </div>
            <ServiceApplyBtn serviceId={1} serviceName={t('routes.training')} />
        </>
    );
};
export default Training;